import React, { FunctionComponent } from "react"

interface RightArrowProps {
  color: string
  size?: string
  isLeft?: boolean
}

const RightArrow: FunctionComponent<RightArrowProps> = ({
  color,
  size = "32",
  isLeft = false,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: isLeft ? "rotate(180deg)" : "rotate(0deg)" }}
    >
      <path
        d="M4.16602 10H15.8327"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 4.16669L15.8333 10L10 15.8334"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default RightArrow
